import state from './inviteState'
import mutations from './inviteMutations'
import getters from './inviteGetters'
import actions from './inviteActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
